import React from "react"
import { Container, Nav } from "react-bootstrap"

export default function () {
  return (
    <div>
      <Container>
        <Nav className="justify-content-center">
          <Nav.Item>
            <Nav.Link href="#" className="text-dark">
              <span>
                <img src={require("../images/blogger.png")} alt="blog" />
              </span>
              <span>Blog</span>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/projects" className="text-dark">
              <span>
                <img src={require("../images/project.png")} alt="project" />
              </span>
              <span>Projects</span>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              href={require("../assets/Resume.pdf")}
              download="Resume"
              target="__blank"
              className="text-dark"
            >
              <span>
                <img src={require("../images/paperclip.png")} alt="resume" />
              </span>
              <span>Resume</span>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link href="/experiments" className="text-dark">
              <span>
                <img src={require("../images/experiment.png")} alt="project" />
              </span>
              <span>Experiment</span>
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Container>
    </div>
  )
}
